import { render, staticRenderFns } from "./ViewItemDepartment.vue?vue&type=template&id=23de5d8a"
import script from "./ViewItemDepartment.vue?vue&type=script&lang=js"
export * from "./ViewItemDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports